import { post } from '@mindtickle/api-helpers';
export { isAdminSite, isWebView } from '../../../utils';
const ApiUrls = {
  mixpanelTrack() {
    return {
      url: `/mixpanel/track`,
    };
  },
};
export const logToMindTickle = async (event, data) => {
  try {
    // disable mixpanel tracking
    if (window && window.disableMixpanelTracking) {
      return;
    }

    const response = await post(ApiUrls.mixpanelTrack(), {
      body: { event, props: data },
    });
    return response;
  } catch (error) {}
};

export default {
  ...window.mixpanel,
  track: (event, data) => {
    if (!process.env.MIXPANEL_PROJECT_ID) {
      logToMindTickle(event, data);
      return;
    }
    window.setTimeout(() => {
      window.mixpanel.track(event, data);
      let mixpanelIds = process.env.MIXPANEL_PROJECT_ID.split('#');
      if (mixpanelIds.length > 1) {
        mixpanelIds.shift();
        mixpanelIds.forEach(mixpanelId => {
          const [, projectName] = mixpanelId.split(':');
          window.mixpanel[projectName].track(event, data);
        });
      }
      logToMindTickle(event, data);
    }, 400);
  },
};

export const timestamp = function () {
  Date.now =
    Date.now ||
    function () {
      return +new Date();
    };
  return Date.now();
};
